import { CaslAbilityContext } from '@/features/Casl/context';
import { createContextualCan } from '@casl/react';

export const Can = createContextualCan(CaslAbilityContext.Consumer);
